var debounce = require("lodash/debounce");
import { slickOnlyMobile } from "../utilities/carouselSlickConfig";

function initClpCarousel() {
    let $slickContainer = $(".category-layout-container");
    let $threeAdvertisementContainer = $(".branding-pages .three-advertising-layout");
    let $eightAdvertisementContainer = $(".eight-advertising-layout-container");

    $slickContainer.not(".slick-initialized").slick(slickOnlyMobile);
    $threeAdvertisementContainer.not(".slick-initialized").slick(slickOnlyMobile);
    $eightAdvertisementContainer.not(".slick-initialized").slick({ ...slickOnlyMobile, slidesToShow: 2 });
}

$(window).on("resize", debounce(function () {
    initClpCarousel();
}, 500));

module.exports = {
    initClpCarousel:initClpCarousel
};
